import axios from 'axios'

export default axios.create({
  baseURL: process.env.ROOT_API,
  timeout: 18000,
  crossDomain: true,
  headers: {
    'Authorization': 'Bearer ' + localStorage.token,
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
})



// WEBPACK FOOTER //
// ./src/services/axios.js